export default {
    F: 'Pessoa Física',
    J: 'Pessoa Jurídica'
}